import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/landing/Navbar';
import Hero from './components/landing/Hero';
import ProblemSolution from './components/landing/ProblemSolution';
import TechStack from './components/landing/TechStack';
import Safety from './components/landing/Safety';
import Fleet from './components/landing/Fleet';
import Impact from './components/landing/Impact';
import Contact from './components/landing/Contact';
import Footer from './components/landing/Footer';

import CaseStudies from './components/landing/CaseStudies';
import PrivacyPolicy from './components/landing/PrivacyPolicy';
import TermsOfService from './components/landing/TermsOfService';
import CookiePolicy from './components/landing/CookiePolicy';

import Services from './components/landing/Services';

function LandingPage() {
  return (
    <div className="min-h-screen bg-background font-sans antialiased selection:bg-secondary selection:text-secondary-foreground">
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <Services />
        <TechStack />
        <Safety />
        <Fleet />
        <Impact />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </Router>
  );
}
